import React, {
  useEffect,
  useRef,
  useImperativeHandle,
  forwardRef,
  useCallback,
} from 'react';

const CHARS = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789';
const WIDTH = 110;
const HEIGHT = 40;

function randomChar() {
  return CHARS[Math.floor(Math.random() * CHARS.length)];
}

function randomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function randomColor(min, max) {
  const r = randomInt(min, max);
  const g = randomInt(min, max);
  const b = randomInt(min, max);
  return `rgb(${r},${g},${b})`;
}

function generateCode(len = 4) {
  return Array.from({ length: len }, randomChar).join('');
}

function drawCaptcha(canvas, code) {
  const ctx = canvas.getContext('2d');
  ctx.clearRect(0, 0, WIDTH, HEIGHT);

  // background
  ctx.fillStyle = '#f0f4ff';
  ctx.fillRect(0, 0, WIDTH, HEIGHT);

  // noise lines
  for (let i = 0; i < 4; i++) {
    ctx.beginPath();
    ctx.moveTo(randomInt(0, WIDTH), randomInt(0, HEIGHT));
    ctx.lineTo(randomInt(0, WIDTH), randomInt(0, HEIGHT));
    ctx.strokeStyle = randomColor(150, 200);
    ctx.lineWidth = 1;
    ctx.stroke();
  }

  // noise dots
  for (let i = 0; i < 40; i++) {
    ctx.beginPath();
    ctx.arc(randomInt(0, WIDTH), randomInt(0, HEIGHT), 1, 0, Math.PI * 2);
    ctx.fillStyle = randomColor(150, 200);
    ctx.fill();
  }

  // characters
  const charWidth = WIDTH / (code.length + 1);
  for (let i = 0; i < code.length; i++) {
    ctx.font = `bold ${randomInt(20, 26)}px Arial`;
    ctx.fillStyle = randomColor(30, 100);
    ctx.save();
    const x = charWidth * (i + 0.8);
    const y = randomInt(24, 32);
    ctx.translate(x, y);
    ctx.rotate((randomInt(-20, 20) * Math.PI) / 180);
    ctx.fillText(code[i], 0, 0);
    ctx.restore();
  }
}

const CaptchaCanvas = forwardRef(function CaptchaCanvas({ onCodeChange }, ref) {
  const canvasRef = useRef(null);
  const codeRef = useRef('');

  const refresh = useCallback(() => {
    const code = generateCode();
    codeRef.current = code;
    if (canvasRef.current) drawCaptcha(canvasRef.current, code);
    onCodeChange?.(code);
  }, [onCodeChange]);

  useImperativeHandle(ref, () => ({ refresh }), [refresh]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <canvas
      ref={canvasRef}
      width={WIDTH}
      height={HEIGHT}
      onClick={refresh}
      title="点击刷新验证码"
      style={{ cursor: 'pointer', borderRadius: 4, display: 'block' }}
    />
  );
});

export default CaptchaCanvas;
